"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var logging_1 = require("@nerdwallet/logging");
var logger = (0, logging_1.getLogger)("localStorage");
/**
 * `useSessionStorage` is an interface for window.sessionStorage.
 *
 * Each key is prefixed with the user's Identity ID to prevent
 * data leakage across multiple user sessions.
 */
var useSessionStorage = function (identityId) {
    var getItem = (0, react_1.useCallback)(function (key) {
        return window.sessionStorage.getItem("".concat(identityId, ":").concat(key));
    }, [identityId]);
    var removeItem = (0, react_1.useCallback)(function (key) {
        window.sessionStorage.removeItem("".concat(identityId, ":").concat(key));
    }, [identityId]);
    var setItem = (0, react_1.useCallback)(function (key, value) {
        try {
            window.sessionStorage.setItem("".concat(identityId, ":").concat(key), value);
        }
        catch (e) {
            // This generally means that the storage is full.
            logger.error(e);
        }
    }, [identityId]);
    return {
        getItem: getItem,
        removeItem: removeItem,
        setItem: setItem,
    };
};
exports.default = useSessionStorage;
